import {
  isActiveHopperProFromUserSubscriptionState,
  isHopperBrand,
  useUserSubscriptionBffState,
} from "@hopper-b2b/utilities";
import { useExperiment } from "./useExperiment";

/**
 * The AI mode entry shows for users in the ConsumerAITabBarEntry experiment.
 * ConsumerAITabBarEntryPro additionally opens it to active Hopper Pro
 * subscribers, so Pro access can be ramped and measured on its own. That path
 * is Hopper-brand only: AtHotel has no /ai route.
 */
export const useIsAIModeEnabled = (): boolean => {
  const inExperiment = useExperiment("ConsumerAITabBarEntry");
  const proEntryEnabled = useExperiment("ConsumerAITabBarEntryPro");
  const subscriptionBffState = useUserSubscriptionBffState();

  return (
    !!inExperiment ||
    (!!proEntryEnabled &&
      isHopperBrand() &&
      isActiveHopperProFromUserSubscriptionState(subscriptionBffState))
  );
};
